import { action, actionBound, observable } from 'mobx';
import qs from 'qs';

class RememberMeStore {
  @observable accessor rememberMe: boolean = false;
  @observable accessor hideRememberMe: boolean;

  public constructor() {
    const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    this.hideRememberMe = params?.hideRememberMe === 'true';
  }

  @actionBound
  public setRememberMe(value: boolean) {
    this.rememberMe = value;
  }
}

export default RememberMeStore;
